export default function () {

    window.addEventListener('load', function(event){
        // Hide Preloader
        var body = document.querySelector('body')
        body.classList.remove('no-scroll')
    })

    setTimeout(function() {  
        removePreloader();
    }, 50);

    function removePreloader(){
        var preloader = document.querySelector('.preloader');
        preloader.style.opacity = '0';

        preloader.addEventListener('transitionend', () => {
            preloader.remove();
        })
    }

}